/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiEntityType } from './InternalApiEntityType';
import {
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeFromJSONTyped,
    InternalApiEntityTypeToJSON,
    InternalApiEntityTypeToJSONTyped,
} from './InternalApiEntityType';

/**
 * 
 * @export
 * @interface InternalApiSegmentResult
 */
export interface InternalApiSegmentResult {
    /**
     * 
     * @type {InternalApiEntityType}
     * @memberof InternalApiSegmentResult
     */
    entityType?: InternalApiEntityType;
    /**
     * 
     * @type {string}
     * @memberof InternalApiSegmentResult
     */
    entityId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiSegmentResult
     */
    versionCode: string;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiSegmentResult
     */
    startTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiSegmentResult
     */
    endTime?: Date;
}



/**
 * Check if a given object implements the InternalApiSegmentResult interface.
 */
export function instanceOfInternalApiSegmentResult(value: object): value is InternalApiSegmentResult {
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    if (!('versionCode' in value) || value['versionCode'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    return true;
}

export function InternalApiSegmentResultFromJSON(json: any): InternalApiSegmentResult {
    return InternalApiSegmentResultFromJSONTyped(json, false);
}

export function InternalApiSegmentResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiSegmentResult {
    if (json == null) {
        return json;
    }
    return {
        
        'entityType': json['entityType'] == null ? undefined : InternalApiEntityTypeFromJSON(json['entityType']),
        'entityId': json['entityId'],
        'versionCode': json['versionCode'],
        'startTime': (new Date(json['startTime'])),
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
    };
}

export function InternalApiSegmentResultToJSON(json: any): InternalApiSegmentResult {
    return InternalApiSegmentResultToJSONTyped(json, false);
}

export function InternalApiSegmentResultToJSONTyped(value?: InternalApiSegmentResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityType': InternalApiEntityTypeToJSON(value['entityType']),
        'entityId': value['entityId'],
        'versionCode': value['versionCode'],
        'startTime': value['startTime'].toISOString(),
        'endTime': value['endTime'] == null ? value['endTime'] : value['endTime'].toISOString(),
    };
}

